<template>
    <div class="instagram-v2-page-selector">
        <div class="page-card">
            <div class="page-card-header">
                <div class="page-card-header-title">Instagram Hesabınızı Seçin</div>
            </div>
            <div class="page-card-body">
                <div class="page-card-body-content">
                    <div class="page-card-body-content-item" v-for="page in getInstagramPages()" :key="page.id">
                        <div class="page-card-body-content-item-image">
                            <img :src="page.instagram_business_account.profile_picture_url || 'https://via.placeholder.com/80'" alt="page image" />
                        </div>
                        <div class="page-card-body-content-item-info">
                            <div class="page-card-body-content-item-info-name">
                                {{ page.instagram_business_account.name || page.instagram_business_account.username }}
                            </div>
                            <div class="page-card-body-content-item-info-username">
                                @{{ page.instagram_business_account.username }}
                            </div>
                        </div>
                        <div class="page-card-body-content-item-action">
                            <SupsisButton primary @click="() => changeValue(page)" :disabled="isConnectedBefore(page)">
                                <span v-if="isConnectedBefore(page)">Connected</span>
                                <span v-else>{{ $t("chatbotv2.select") }}</span>
                            </SupsisButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "InstagramV2PageSelector",
    components: {
        SupsisButton,
    },
    props: {
        pages: {
            type: Array,
            required: true,
            default: () => [],
        },
        value: String,
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    computed: {
        ...mapState({
            instagramV2Channels: (state) => state.channel.channels.filter((x) => x.type === "instagram-v2"),
        }),
    },
    methods: {
        getInstagramPages() {
            return this.pages.filter((x) => !!x.instagram_business_account);
        },
        changeValue(page) {
            this.clone = page;
        },
        isConnectedBefore(page) {
            return this.instagramV2Channels.some((x) => {
                const id = x.payload?.page?.instagram_business_account?.id;
                const currentId = page?.instagram_business_account?.id;
                return id === currentId;
            });
        },
    },
    created() {
        this.clone = _.cloneDeep(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(value) {
                if (_.isEqual(value, this.clone)) return;
                this.clone = _.cloneDeep(value);
            },
        },
        clone: {
            deep: true,
            handler(value) {
                this.$emit("input", value);
            },
        },
    },
});
</script>

<style scoped lang="scss">
.instagram-v2-page-selector {
    .page-card {
        border-radius: 8px;
        overflow: hidden;

        .page-card-header {
            background-color: #f5f5f5;
            padding: 16px;

            .page-card-header-title {
                font-size: 18px;
                font-weight: 500;
            }
        }

        .page-card-body {
            .page-card-body-content {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                gap: 16px;
                padding: 16px;

                .page-card-body-content-item {
                    background-color: #fff;
                    border-radius: 8px;
                    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                    display: flex;
                    padding: 16px;

                    .page-card-body-content-item-image {
                        flex: 0 0 80px;

                        img {
                            border-radius: 50%;
                            height: 80px;
                            width: 80px;
                        }
                    }

                    .page-card-body-content-item-info {
                        flex: 1;
                        padding: 0 16px;

                        .page-card-body-content-item-info-name {
                            font-size: 16px;
                            font-weight: 500;
                        }

                        .page-card-body-content-item-info-username {
                            color: #666;
                            font-size: 14px;
                        }
                    }

                    .page-card-body-content-item-action {
                        flex: 0 0 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }
    }
}
</style>
